module.exports = __webpack_public_path__ + "static/accounts_azure_2-7c3f66cac4a9db2ae1104fa14b0eb897.png";